var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWebappMobileSave = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M16.657 17.265a.79.79 0 0 1-1.33.518l-4.345-4.108a1.429 1.429 0 0 0-1.963 0l-4.345 4.108a.79.79 0 0 1-1.331-.518 104 104 0 0 1-.069-13.571C3.362 2.21 4.604 1.07 6.091 1.07h7.819c1.486 0 2.728 1.14 2.816 2.623.268 4.52.254 9.051-.069 13.57Z",
  stroke: "#3A434A",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgWebappMobileSave;